export default __webpack_public_path__ + "static/media/dive_shot16.47aa7993.png";